import { QuestionBase } from '../question-types/question-base';
import { alert as notieAlert } from 'notie';

export class UploadQuestion extends QuestionBase<string> {
  controlType = 'upload';
  onChange?: Function;
  type: string;
  filename: string;
  acceptedFormats: string[];

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
    this.onChange = options['onChange'];
    this.acceptedFormats = options['acceptedFormats'] || [];
  }

  onFilesAdded(files: FileList) {
    const file = files.item(0);
    this.filename = file.name;
    if (this.acceptedFormats.every(format => !this.filename.endsWith(format))) {
      notieAlert({
        type: 2,
        stay: true,
        text: `The format received does not match our supported formats: ${this.acceptedFormats.toString()}, please select a different file with one of these formats`
      });
    } else {
      this.onChange(file);
    }
  }
}
